// Escape-exits-Max handler (CFR-VW-145 redesign: "Esc exits"). Extracted verbatim from
// AppShell.tsx so the contract is unit-testable without mounting the full provider stack.
// `maxed` is the caller's chromeless-safety derivation (`appMax && hasActiveApp`) — the
// listener only exists while actually maxed, so plain Escape presses in normal chrome
// never touch the store.
import { useEffect } from "react";
import { useShellStore } from "./shellStore";

export function useMaxEsc(maxed: boolean): void {
  const setAppMax = useShellStore((s) => s.setAppMax);
  useEffect(() => {
    if (!maxed) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") setAppMax(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [maxed, setAppMax]);
}
